<template>
<svg data-svg-lvl-3="cover-back-contour" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 514 430"><defs></defs><g id="Задник_Контур"><path class="bc-c-3" d="M392.24,16H123.7a10.58,10.58,0,0,0-7.47,3.1l-2.06,2.06a3.5,3.5,0,0,0-1,2.49c0,1.73,0,352,0,388.12a3,3,0,0,0,3,3H392.24a9.13,9.13,0,0,0,9.13-9.13V25.13A9.16,9.16,0,0,0,392.24,16Z"/></g></svg></template>


<script>
/** Этот компонент генерируется автоматически, руками ничего менять нельзя!!! */
  
export default {props: { params: { type: Object, required: true, }, }, data() { return {} },}
</script>

<style scoped>.bc-c-1{opacity:0.3;}.bc-c-2{fill:#64ff00;}.bc-c-3{fill:gray;stroke:#232728;stroke-miterlimit:2;stroke-width:1.14px;}</style>

